"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlHashTabs = void 0;
var UrlHashTabs;

(function (UrlHashTabs) {
  UrlHashTabs["Products"] = "#products";
  UrlHashTabs["ProductCategory"] = "#product-category";
  UrlHashTabs["TheGauge"] = "#the-gauge";
  UrlHashTabs["Locations"] = "#locations";
  UrlHashTabs["Other"] = "#other";
})(UrlHashTabs || (exports.UrlHashTabs = UrlHashTabs = {}));